import $ from 'jquery';

export default {
  init () {
    $('.js-expandable .js-open').on('click', this.onToggle)
  },
  onToggle () {
    $(this).parent().toggleClass('open')
  },
};
